/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
//actions
import { resetForm } from '@insticator/insticator-ui';
import { updatePageDetails, changePage } from '@insticator/insticator-ui';
import { setFormEditableState, discardChanges } from '@insticator/insticator-ui';
import { savePaymentInformationWithValidation, getPaymentInformation } from 'state/actions/accountState/account_data';
// component
import PaymentInfo from 'pages/dashboard/account/paymentinfo/paymentinfo';



/* ========== ~~~~~~~~~~ ACCOUNT PAYMENT INFO : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ accountData, sessionStatus, appStatus }) => ({

    fields: accountData.selectedPaymentType === 'NONE' ? null : accountData[accountData.selectedPaymentType].fields,
    savingData: accountData.selectedPaymentType === 'NONE' ? null : accountData[accountData.selectedPaymentType].savingData,
    editable: accountData.selectedPaymentType === 'NONE' ? null : accountData[accountData.selectedPaymentType].editable,
    hasStoredData: accountData.selectedPaymentType === 'NONE' ? null : Object.keys(accountData[accountData.selectedPaymentType].storedData).length > 0,
    formName: accountData.selectedPaymentType,
    paymentInfoReceived: accountData.paymentInfoReceived,
    selectedPaymentType: accountData.selectedPaymentType,
    paymentInfo: accountData.paymentInfo,
    payoutThreshold: accountData.payoutThreshold,
    savedPaymentInfo: accountData.paymentInfo.length > 0,
    savedPaymentTypes: accountData.savedPaymentTypes,
    accountUUID: sessionStatus.accountUUID,
    paymentInfoPermitted: sessionStatus.mocked || sessionStatus.permissions.includes('settings.paymentInfo'),
    mocked: sessionStatus.mocked,
    permissions: sessionStatus.permissions,
    currentPage: appStatus.currentPage,
    previousPage: appStatus.previousPage
});

// map actions
const mapDispatchToProps = dispatch => ({
    resetForm: formName => dispatch(resetForm(formName)),
    setFormEditableState: (formName, isEditable) => dispatch(setFormEditableState(formName, isEditable)),
    discardChanges: (formName) => dispatch(discardChanges(formName)),
    savePaymentInformationWithValidation: ( data, paymentType, fields, accountUUID ) => dispatch(savePaymentInformationWithValidation(fields, data, paymentType, accountUUID)),
    getPaymentInformation: (accountUUID) => dispatch(getPaymentInformation(accountUUID)),
    moveToPage: (location) => {
        dispatch(updatePageDetails(location));
        dispatch(changePage(location))
    },
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PaymentInfo);

